import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CircleChevronDown.svg",
  "use": "CircleChevronDown.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"CircleChevronDown.svg\"><path d=\"M8,32A24,24,0,1,1,32,56,24,24,0,0,1,8,32Zm25.3973,9.44L44.4019,30.4173a2.0015,2.0015,0,1,0-2.8288-2.8324l-9.59,9.6064-9.59-9.6064a2.0016,2.0016,0,0,0-2.829,2.8324L30.5684,41.44A1.9984,1.9984,0,0,0,33.3975,41.44Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol